import { Effect, Layer } from "effect";
import { BrowserHttpClient } from "@effect/platform-browser";
import { withWorkerstationBase } from "@workerstation/shared";
import { WorkerBindingsApi } from "../../api/worker-bindings/service.ts";
import { makeWorkerBindingsApi } from "../../api/worker-bindings/live.ts";

export const WorkerBindingsBrowserPortsLive = Layer.effect(WorkerBindingsApi, Effect.gen(function* () {
  const base = yield* Effect.sync(() => (typeof window === "undefined" ? "https://workerstation.invalid" : window.location.origin) + withWorkerstationBase(""));
  return yield* makeWorkerBindingsApi(base);
})).pipe(Layer.provide(BrowserHttpClient.layerFetch));
